import Clear from './../layouts/Clear.vue';

export default {
  path: '/assets',
  component: Clear,
  children: [
    {
      path: '',
      name: 'assets.index',
      component: () => import('@/views/assets/index.vue'),
    },
  ],
};
